import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContactInfoBlock from '../components/contact-info';
import ContactForm from '../components/contact-us/form';
import SEO from '../components/seo';
import Spacer from '../components/spacer';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 640,
    padding: theme.spacing(15, 5),
    margin: '0 auto'
  },
  title: {
    marginBottom: theme.spacing(5),
    textTransform: 'uppercase'
  }
}));

const ContactUs = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Contact Us" />
      <Spacer />

      <div className={classes.root}>
        <Typography className={classes.title} variant="h1" align="center">
          {t('contactUsPage.pageTitle')}
        </Typography>

        {/* Form */}
        <ContactForm />

        {/* Address and socila links */}
        <ContactInfoBlock />
      </div>
    </>
  );
};

export default ContactUs;
